export default {
    INSTALL_APP: 'InstallApp',
    DASHBOARD: 'Dashboard',
    PRICING: 'Pricing',
    APP_DIRECTORY: 'AppDirectory',
    CHOOSE_PLAN: 'ChoosePlan',
    UPDATE_APP: 'UpdateApp',
    ACCOUNT_SETTINGS: 'AccountSettings',
    ERROR_404: 'Error404',
    ERROR_500: 'Error500',
    PAGE_NOT_FOUND: 'PageNotFound',
    OPTIMIZE_IMAGE: 'OptimizeImage',
    OPTIMIZATION_DETAIL: 'OptimizationDetail',
    PRELOADING: 'Preloading',
    LOADING_SCREEN: 'LoadingScreen',
    ONBOARD: 'Onboard',
    ONBOARD_SET_UP: 'OnboardSetUp',
    SWIFT_EXPERT: 'SwiftExpert',
    MAINTENANCE: 'Maintenance',
    PROMOTION: 'Promotion'
}
